import React from "react";
import LegalPageShell from "@/components/LegalPageShell";

const Terms = () => (
  <LegalPageShell
    dictionaryKey="terms"
    testid="terms-page"
    sectionKeys={["acceptance", "services", "obligations", "ip", "liability", "law"]}
  />
);

export default Terms;
